import { TimePicker } from 'antd'
import React, { useEffect } from 'react'
import SelectInput from '../../components/UI/SelectInput'
import { IBusynessDayProps } from './types'
import {sendSystemLog, useAuth} from "../../context/AuthProvider/useAuth";
import dayjs from "dayjs";
const format = 'HH:mm';


function BusinessDay(props: IBusynessDayProps) {

  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'business_day'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const timezoneOptions = props.timeZones.map((a) => {
    return {name: a, value: a}
  })

  const {canEdit} = useAuth()

  return (
    <>
      <SelectInput
        label="Systemwide timezone"
        onSelectChange={(e) => props.setConfig(e?.value ? e.value : e, 'TIMEZONE')}
        options={timezoneOptions}
        value={props.config.TIMEZONE}
        disabled={!canEdit}
      />
      <div className="input-component">
        <div className="input-component__label">
          Business start
        </div>
        <div className="input-component__input">
          <TimePicker 
            value={dayjs(props.config.START_TIME, format)}
            format={format}
            allowClear={false}
            onChange={(e) => props.setConfig(dayjs(e).format(format), 'START_TIME')}
            disabled={!canEdit}
          />
        </div>
      </div>
      <div className="input-component">
        <div className="input-component__label">
          Business end
        </div>
        <div className="input-component__input">
          <TimePicker 
            value={dayjs(props.config.FINISH_TIME, format)}
            format={format}
            allowClear={false}
            onChange={(e) => props.setConfig(dayjs(e).format(format), 'FINISH_TIME')}
            disabled={!canEdit}
          />
        </div>
      </div>
      
    </>
  )
}

export default BusinessDay